export const API_URL = "https://test.api.societe.helpp-life.fr/api/client";
export const SOCIETE_URL = "https://test.api.societe.helpp-life.fr/api/societe";
export const LOGIN_URL = "https://test.api.societe.helpp-life.fr/login";
export const GOOGLE_API_KEY = "AIzaSyBPG5mwyzJa8XSsd323RdpcB4th47aArrk";
